const constants = {
  FILTERS: {
    list: 'list',
    reportsProgressMilestone: 'reports-progress-milestone',
    reportsProgressStatuses: 'reports-progress-statuses',
    reportsProgressSchedule: 'reports-progress-schedule',
    reportsProgressPortfolio: 'reports-progress-portfolio',
    reportsProgressMonth: 'reports-progress-month',
    reportsBudgetProject: 'reports-budget-project',
    reportsBudgetMonth: 'reports-budget-month',
    reportsTimeProject: 'reports-time-project',
    reportsTimeMonth: 'reports-time-month',
  },
  EMPTY_PROPERTIES: {
    gantt_id: '',
    portfolio_id: '',
    type: '',
    status: '',
    assignee: '',
    priority: '',
    reporter: '',
    startDate: '',
    rangeDate: '',
    endDate: '',
    creationDate: '',
    color: '',
    text: '',
    overdue: false,
    comment: '',
    resource_id: '',
    date: '',
    time: '',
    owner_id: '',
    project_status: '',
  },
  PROPERTY: {
    gantt_id: 'gantt_id',
    portfolio_id: 'portfolio_id',
    text: 'text',
    type: 'type',
    date: 'date',
    resource_id: 'resource_id',
    assignee: 'assignee',
    status: 'status',
    priority: 'priority',
    color: 'color',
    rangeDate: 'rangeDate',
    startDate: 'startDate',
    endDate: 'endDate',
    creationDate: 'creationDate',
    overdue: 'overdue',
    comment: 'comment',
    time: 'time',
    reporter: 'reporter',
    owner_id: 'owner_id',
    project_status: 'project_status',
  },
  STATUS_OPTIONS: [
    {
      id: '1',
      value: __('filter_status_open'),
      icon: {
        name: 'status-2',
        type: 'bold',
        size: 20,
        color: '#9b9b9b',
      },
    },
    {
      id: '2',
      value: __('filter_status_in_progress'),
      icon: {
        name: 'status-2',
        type: 'bold',
        size: 20,
        color: '#ff9921',
      },
    },
    {
      id: '3',
      value: __('filter_status_done'),
      icon: {
        name: 'status-2',
        type: 'bold',
        size: 20,
        color: '#55BED4',
      },
    },
    {
      id: '4',
      value: __('filter_status_closed'),
      icon: {
        name: 'status-2',
        type: 'bold',
        size: 20,
        color: '#14bb4c',
      },
    },
  ],
  PRIORITY_OPTIONS: [
    {
      id: '5',
      value: __('filter_priority_highest'),
      icon: {
        name: 'priority',
        type: 'bold',
        size: 20,
        color: '#DD3636',
      },
    },
    {
      id: '6',
      value: __('filter_priority_high'),
      icon: {
        name: 'priority',
        type: 'bold',
        size: 20,
        color: '#FFC266',
      },
    },
    {
      id: '7',
      value: __('filter_priority_medium'),
      icon: {
        name: 'priority',
        type: 'bold',
        size: 20,
        color: '#81C784',
      },
    },
    {
      id: '8',
      value: __('filter_priority_low'),
      icon: {
        name: 'priority-2',
        type: 'bold',
        size: 20,
        color: '#999999',
      },
    },
    {
      id: '9',
      value: __('filter_priority_lowest'),
      icon: {
        name: 'priority-2',
        type: 'bold',
        size: 20,
        color: '#CCCCCC',
      },
    },
  ],
  TYPE_OPTIONS: [
    {
      id: 'task',
      value: __('filter_task_type_task'),
      icon: {
        name: 'task',
        type: 'regular',
        size: 24,
        color: '#B2B2B2',
      },
    },
    {
      id: 'milestone',
      value: __('filter_task_type_milestone'),
      icon: {
        name: 'milestone',
        type: 'regular',
        size: 24,
        color: '#B2B2B2',
      },
    },
  ],
};

export default constants;
